import React from 'react';
import Grid from '@material-ui/core/Grid';
import { PhoneNumberModel } from '@utmost.co/enterprise-models';
import { SelectValue } from '../../index';
import { ReadOnly } from '../../atoms/ReadOnly/ReadOnly';
import { DEFAULT_CALLING_CODE, InternationalPhoneNumber } from '../../forms/utils';

interface PhoneNumberRowReadOnlyProps {
  deviceTypes: SelectValue[];
  name: string;
  value?: Partial<PhoneNumberModel>;
}

export const PhoneNumberRowReadOnly: React.FC<
  React.PropsWithChildren<Partial<PhoneNumberModel> & PhoneNumberRowReadOnlyProps>
> = ({ value, name, deviceTypes }) => (
  <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start">
    <Grid item xs={3}>
      <ReadOnly label="" value={deviceTypes.find((type) => type.value === value?.deviceType)?.label} />
    </Grid>
    <Grid item xs={5}>
      <ReadOnly
        permissionsId={name}
        label=""
        value={
          value
            ? new InternationalPhoneNumber({
                areaCode: value?.areaCode ?? '',
                number: value?.number ?? '',
                countryCode: value?.countryCode ?? DEFAULT_CALLING_CODE
              }).toPrettyFormat()
            : undefined
        }
      />
    </Grid>
    {value?.primary && (
      <Grid item xs={2}>
        <ReadOnly label="" value="Primary" />
      </Grid>
    )}
  </Grid>
);
